import ReactMarkdown from "react-markdown";
import Container from "../Container";
import useTranslation, { useRoutes } from "../../helpers/translationTexts/useTranslation";
import { Content } from "@/types/PropTypes";
import {
  ContentWrapper,
  HowToPlayWrapper,
  MainContentWrapper,
  SideBarStyledLinkSudoku,
  SideBarSudokuBanner,
  SideBarWrapper,
  StyledLinkSudoku,
  SudokuBanner,
} from "./HowToPlay.components";

const HowToPlay = ({ content }: Content) => {
  const playOnlineText = useTranslation("playOnline");
  const pathName = useRoutes().Root;

  return (
    <Container>
      <HowToPlayWrapper>
        <MainContentWrapper>
          <ContentWrapper>
            <ReactMarkdown>{content}</ReactMarkdown>
          </ContentWrapper>

          <SudokuBanner>
            <StyledLinkSudoku href={pathName} name={playOnlineText} />
          </SudokuBanner>
        </MainContentWrapper>

        <SideBarWrapper>
          <SideBarSudokuBanner>
            <SideBarStyledLinkSudoku href={pathName} name={playOnlineText} />
          </SideBarSudokuBanner>
        </SideBarWrapper>
      </HowToPlayWrapper>
    </Container>
  );
};

export default HowToPlay;
